type CheckboxProps = {
  name: string
  onChange?: (event: React.FormEvent<HTMLInputElement>) => void
  checked: boolean
  label: string
  labelClassName?: string
  inputClassName?: string
  containerClassName?: string
}

const Checkbox = ({
  name,
  onChange,
  checked = false,
  label,
  labelClassName = "",
  inputClassName = "",
  containerClassName = "",
}: CheckboxProps) => {
  return (
    <div
      className={`w-full flex flex-row justify-between bg-zinc-900 shadow-md rounded-xl p-4 items-center gap-4 ${containerClassName}`}
    >
      <label className={`text-white text-sm ${labelClassName}`}>{label}</label>
      <input
        name={name}
        type="checkbox"
        onChange={onChange}
        checked={checked || false}
        className={`bg-zinc-900 w-8 h-8 outline-none border-2 border-zinc-700 rounded-xl ${inputClassName}`}
      />
    </div>
  )
}

export default Checkbox
